import React from "react";
import style from "./Main.module.css";
import { Link } from "react-router-dom";
export default function Main() {
  return (
    <div className={style.mainContainer}>
      <div className={style.innerContainer}>
        <section className={style.introductionSlogan}>
          <h1 className={style.sloganText}>
            TECHNOLOGY <strong>PARTNER</strong> FOR <strong>INNOVATORS</strong>
            <br></br>WE TURN YOUR
            <strong> VISION</strong> INTO <strong> DIGITAL REALITY</strong>.
          </h1>
        </section>

        <section className={style.introSectionDesc}>
          <p className={style.descriptionText}>
            InvoZone is proudly serving a global clientele through cutting-edge
            and brilliant<br></br>
            outsourcing software development solutions and quality services!
          </p>
          <Link to="/contact-us">
            <button className={style.talkBtn}>Let's Talk</button>
          </Link>
        </section>
        <section className={style.imageContainer}>
          <img
            alt="Desk"
            src="https://invozone.com/wp-content/uploads/2020/04/banner-vector-min.png"
            className={style.imgDesk}
          ></img>
        </section>
      </div>
    </div>
  );
}
